import { DataTableCellValue, DataTableRowData } from "../../components/data-table/types";
import { formatNullCellValue } from "../../components/data-table/utils";
import { TableColumnFromApi } from "../../hooks/use-config-context/types";
import { buildTableCellFormatters } from "../../utils/table-cell-formatters";
import { FieldsConfigResponse } from "@hooks/use-config-context/types";
import { WpAsset } from "@hooks/use-get/assets/types";

export const buildAssetTableCellFormatters = (
  columns: TableColumnFromApi<any>[],
  config: FieldsConfigResponse,
  openAssetModal?: (data?: any) => void,
  tableData?: WpAsset[]
) => {
  // Use shared formatter builder
  const formatters = buildTableCellFormatters(columns, config);

  // Add asset-specific formatter for "title" column
  formatters["title"] = (value: DataTableCellValue, rowData?: DataTableRowData) => {
    return (
      <span
        className={"link"}
        onClick={(e) => {
          e.stopPropagation();
          const asset = tableData?.find((a) => a.id === rowData?.id);
          if (asset && openAssetModal) {
            openAssetModal(asset);
          }
        }}
      >
        {formatNullCellValue(value)}
      </span>
    );
  };

  return formatters;
};
